module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_VN.742fb7f6.webp";